<template>
	<div class="MAM_stockList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="stockForm" class="demo-form-inline">

				<el-form-item>
					<el-input size clearable v-model="stockForm.terminal_sn" placeholder="请输入SN"></el-input>
				</el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="stockForm.ch_merchant_name" placeholder="请输入商户名称"></el-input>
                </el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="stockForm.channel_mer_no" placeholder="请输入商户编号"></el-input>
                </el-form-item>
                <el-form-item>
                	<el-select size clearable v-model="stockForm.brand_id" placeholder="请选择政策名称" style="width:180px;">
                		<el-option :label="item.name" :value="item.id" v-for="(item,index) in optionList"></el-option>
                	</el-select>
                </el-form-item>
                <el-form-item>
                	<el-select size="medium" v-model="stockForm.form_type" filterable clearable style="width:100%"
                		placeholder="请选择收入类型">
                		<el-option label="冻结押金奖励" value="2"></el-option>
                		<el-option label="交易激活奖励" value="3"></el-option>
                		<el-option label="申请退回收入" value="4"></el-option>
                        <el-option label="积分兑换收入" value="5"></el-option>
                	</el-select>
                </el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="stockForm.phone" placeholder="请输入直属代理商账号"></el-input>
                </el-form-item>
				<el-form-item>
					<el-input size clearable v-model="stockForm.s_phone" placeholder="请输入所属机构账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-date-picker size clearable v-model="rangeDate" type="datetimerange" range-separator="至"
						start-placeholder="奖励开始日期" end-placeholder="奖励结束日期" value-format="yyyy-MM-dd"
						@change="pickerChange"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(stockForm)">查询</el-button>
					<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
						:loading="downLoading" @click="handleDownLoad(stockForm)">导出数据</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column header-align="center" align="center" fixed type="index" label="ID"
					min-width="80"></el-table-column>
				<el-table-column header-align="center" align="center" prop="terminal_sn" label="SN"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="ch_merchant_name" label="商户名称"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="channel_mer_no" label="商户编号"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="brand_name" label="政策名称"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="cash_money" label="押金信息"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="form_type_text" label="积分收入类型"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="create_time" label="交易时间"
					min-width="160"></el-table-column>
				<el-table-column header-align="center" align="center" prop="points" label="奖励积分"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="u_nickname" label="直属代理商昵称"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="u_phone" label="直属代理商账号"
					min-width="120"></el-table-column>
                 <el-table-column v-if="level<2" header-align="center" align="center" prop="s_nickname" label="所属机构昵称"
                 	min-width="120"></el-table-column>
                <el-table-column  v-if="level<2" header-align="center" align="center" prop="s_phone" label="所属机构账号"
                	min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="audit_time" label="奖励时间"
					min-width="160"></el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>

	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "exchangePointIncome",
		data() {
			return {
				level: sessionStorage.getItem('level'),
				rangeDate: '',
				optionList: [],
				stockForm: {
					terminal_sn: '',
                    ch_merchant_name:'',
					channel_mer_no: '',
                    form_type:'',
					phone: '',
                    s_phone:'',
					start_time: '',
					end_time: '',
					brand_id: '',
				},
				stockTable: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 100 //总数
				},
				loading: true
			}
		},
		mounted() {
			this.brandList();
			//初始化
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize
			})
		},
		components: {
			paginations,
		},
		methods: {
			//导出
			handleDownLoad(params) { 
				let reqData = {
					type: 28,
					value: JSON.stringify(params),
				};
				console.log(reqData);
				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}
			
				})
			},
			//获取2.0政策
			brandList() {
				this.$api.post("userlevel/selBrandList", {}, res => {
					this.optionList = res.data;
				})
			},
			pickerChange(DateArr) { //时间选择器
				this.stockForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.stockForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			onSearch(stockForm) {
				this.page.currentPage = 1;
				stockForm.page = this.page.currentPage;
				stockForm.limit = this.page.pageSize;
				// 表单提交
				this.getData(stockForm);
			},

			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.loading = true;
				this.page.currentPage = page;
				this.stockForm.page = page;
				this.stockForm.limit = this.page.pageSize;
				this.getData(this.stockForm)
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.loading = true;
				this.page.pageSize = limit;
				this.stockForm.page = this.page.currentPage;
				this.stockForm.limit = limit;
				this.getData(this.stockForm);
			},
			getData(params) {
				this.$api.post("user_points/getAdminUserPointsPage", params, res => {
					let data = res.data;
					this.page.total = data.count; //总数
					this.stockTable.list = data.list;
                    this.dataItem = data
					//渲染结束后取消加载
					this.loading = false;
				});
			}
		},

	};
</script>

<style lang="scss" scope>
	.MAM_stockList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>